export default "__VITE_IMAGE_ASSET__fb9c6bda__";